import React from "react";
import { Iframe } from "../iframe/iframe.layout";
import { EducationFormHeader } from "./educationFormHeader";
import { PostMessage } from "../iframe/iframe.state";
import { EventTemplate } from "../models/Events/Events";
import { CoursePage } from "../cmsPage/cmsPageState";

type educationFormProps = {
  eventId: string
  eventData: EventTemplate
  pageData: CoursePage,
  embedCode: string
  width?: number | string
  height?: number
  handlePostMessage?: (m: PostMessage) => void
};

export const EducationFormLayout = (props: educationFormProps): JSX.Element => {
  let { eventData, pageData, eventId, embedCode, handlePostMessage } = props
  const title = `iframe-${eventId}`
  const url = `${window.EventRegisterHost}/inschrijven/?id=${eventId}`

  return <div className="region">
    <EducationFormHeader event={eventData} pageData={pageData} />
    <Iframe
      messageOrigin={window.EventRegisterHost}
      handlePostMessage={handlePostMessage}
      title={title}
      url={url}
      embedCode={embedCode == '' ? null! : embedCode}
      onLoaded={() => {null}}
      loading="eager"
    />
  </div>;
}
